<!-- FakeButton.svelte -->

<script>
	import Icon from "../icons/Icon.svelte";

	function handleClick(event) {
	}

	export let onClick = handleClick;
	export let iconName;
</script>

<div
	class="fake-button"
	role="button"
	tabindex="0"
	on:click={onClick}
	on:keypress={onClick}
>
	<slot></slot>
	{#if iconName}
		<Icon name={iconName} />
	{/if}
</div>

<style>
	.fake-button {
		position: relative;
		display: flex;
		justify-content: center;
		align-items: center;
		background-color: transparent;
		cursor: pointer;
		transition: background-color 0.3s ease;
	}

	.fake-button::before {
		content: "";
		position: absolute;
		width: 200%;
		height: 200%;
		min-height: 20px;
		min-width: 20px;
		background-color: rgba(0, 0, 0, 0.05);
		border-radius: 20%;
		transition:
			transform 0.3s,
			background-color 0.3s;
		transform: scale(0);
	}

	.fake-button:hover::before {
		transform: scale(1);
	}

	.fake-button:active::before {
		background-color: rgba(0, 0, 0, 0.2);
	}
</style>
